import { useGetStepTypesQuery } from "api/TenantSlug/ConnectionCreator/hooks.ts";
import { useStepTypeLabel } from "components/UI/Selects/StepTypeSelectSearchable/useStepTypeLabel.ts";

const HIDDEN_STEP_TYPES = ["blank", "event_watcher", "scenario", "repeater", "scheduler"];

// Start-type BE values — each represents a different flow context
const START_TYPE_BE_VALUES: Record<StepTypeStartContext, string> = {
    integration: "integration",
    outgoing_postback: "outgoing_postback",
    incoming_postback: "incoming_postback",
    structure: "structure",
};

/**
 * When provided, limits the step type select to one start context:
 * - filters out other start types
 * - strips the " - <suffix>" from the matching start type label
 */
export type StepTypeStartContext = "integration" | "outgoing_postback" | "incoming_postback" | "structure";

export const useStepTypeSelectOptions = (startContext?: StepTypeStartContext) => {
    const { data, isLoading, error } = useGetStepTypesQuery({});
    const getLabel = useStepTypeLabel();

    const otherStartTypes = startContext
        ? Object.values(START_TYPE_BE_VALUES).filter((v) => v !== START_TYPE_BE_VALUES[startContext])
        : [];

    const options = (data?.types ?? [])
        .filter((type) => !HIDDEN_STEP_TYPES.includes(type))
        .filter((type) => !otherStartTypes.includes(type))
        .map((type) => {
            const label = getLabel(type);
            const isContextStart = startContext && type === START_TYPE_BE_VALUES[startContext];
            return {
                label: isContextStart ? label.split(" - ")[0] : label,
                value: type,
            };
        })
        .sort((a, b) => a.label.localeCompare(b.label));

    return {
        options,
        loading: isLoading,
        error: error ? String(error) : null,
    };
};
